import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Las 3 Jarras — El Sistema Familiar para que tus hijos aprendan dinero sin peleas';
render(<App data-id="element-435" />, document.getElementById('root'));